import { getTextColorForBackground, isValidHexColor } from "@utils";
import classNames from "classnames";

export function Pill({
  children,
  className,
  color = "#00609b",
}: {
  children: React.ReactNode;
  className?: string;
  color?: string;
}) {
  const hasBgClass = className && /\bbg-/.test(className);
  const shouldUseCustomColor = !hasBgClass && isValidHexColor(color);
  const textColor = shouldUseCustomColor
    ? getTextColorForBackground(color)
    : "";

  const style = shouldUseCustomColor
    ? {
        backgroundColor: color,
      }
    : undefined;

  return (
    <div
      className={classNames(
        "text-xs rounded-full px-2 py-1 flex justify-center items-center w-fit",
        shouldUseCustomColor ? textColor : !hasBgClass ? "bg-primary-500" : "",
        className,
      )}
      style={style}
    >
      {children}
    </div>
  );
}
